import React from 'react'
import AnimatedPageContainer from 'src/containers/AnimatedPageContainer/AnimatedPageContainer'

const AlternateRenderMessage = ({ children }) => (
    <AnimatedPageContainer>
        <div className="align-center">{children}</div>
    </AnimatedPageContainer>
)

export default AlternateRenderMessage